<template>
  <div>
    <div v-if="user">
      <h1>TODO: Users page ...</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "users",
  props: ["user"]
};
</script>
